import React, { useState } from 'react';
import { Camera, ChevronLeft } from 'lucide-react';
import RoleSelection from './biomechanics/RoleSelection';
import VideoInput from './biomechanics/VideoInput';
import PoseAnalyzer from './biomechanics/PoseAnalyzer'; // We'll create this next

const BiomechanicsModule = () => {
  const [step, setStep] = useState('role'); // role, input, analyze
  const [role, setRole] = useState(null); // bowler, batsman
  const [videoSrc, setVideoSrc] = useState(null);

  const handleRoleSelect = (selectedRole) => {
    setRole(selectedRole);
    setStep('input');
  };

  const handleVideoSelect = (src) => {
    setVideoSrc(src);
    setStep('analyze');
  };

  const handleBack = () => {
    if (step === 'input') setStep('role');
    if (step === 'analyze') setStep('input');
  };

  return (
    <div className="flex flex-col h-full bg-gray-900 text-white">
      {/* Header */}
      <div className="p-4 bg-gray-800 border-b border-gray-700 flex justify-between items-center">
        <div className="flex items-center">
          {step !== 'role' && (
            <button onClick={handleBack} className="mr-2 p-1 hover:bg-gray-700 rounded-full">
              <ChevronLeft size={20} />
            </button>
          )}
          <h2 className="text-xl font-bold flex items-center text-neon-cyan">
            <Camera className="mr-2" /> Biomechanics Lab
          </h2>
        </div>

        <div className="text-xs font-mono text-gray-500">
          {step !== 'role' && <span className="uppercase">{role} Analysis</span>}
        </div>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-y-auto relative bg-black custom-scrollbar">
        {step === 'role' && <RoleSelection onSelect={handleRoleSelect} />}
        {step === 'input' && <VideoInput onVideoSelect={handleVideoSelect} />}
        {step === 'analyze' && (
          <PoseAnalyzer
            videoSrc={videoSrc}
            role={role}
            onRestart={() => setStep('input')}
          />
        )}
      </div>
    </div>
  );
};

export default BiomechanicsModule;




